import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { BCSaaSOrganizationRoleEntity } from '@bluecypress/bcsaas-entities';
import { IAdminPanel, AdminPanelStatus, DEFAULT_ADMIN_PANEL_STATUS } from '../admin-panel.interface';

/**
 * Contact-roles admin component.
 *
 * Post-BCSaaS-v1.3.x: BC: Contact Roles was eliminated and replaced by
 * BC: Organization Roles (seeded system table with DisplayName + Level +
 * IsAssignable + IsDefault). The new model is not user-CRUDable from the
 * admin UI — roles are managed by BCSaaS migrations and OrganizationRole_Refactor.
 *
 * This component is kept as a read-only stub for now. A future feature could
 * expose a role-catalog browser, but the legacy edit/create/delete flow is
 * intentionally disabled.
 */
@Component({
  standalone: false,
  selector: 'izzy-contact-roles',
  templateUrl: './contact-roles.component.html',
  styleUrls: ['./contact-roles.component.css']
})
export class ContactRolesComponent implements OnInit, OnDestroy, IAdminPanel {
  @Input() initialState: any = null;
  @Output() stateChange = new EventEmitter<any>();
  @Output() statusChange = new EventEmitter<AdminPanelStatus>();
  @Output() interaction = new EventEmitter<any>();

  protected roles: BCSaaSOrganizationRoleEntity[] = [];
  protected isLoading: boolean = false;
  protected errorMessage: string = '';

  private destroy$ = new Subject<void>();

  constructor() {}

  ngOnInit(): void {
    this.statusChange.emit(DEFAULT_ADMIN_PANEL_STATUS);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

export function LoadContactRolesComponent(): void {}
